import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { usePosition } from 'use-position';
import { hotjar } from 'react-hotjar';
import { setUserPos } from './actions';
import Home from './containers/Home/Home';
import Search from './containers/Search/Search';

import BurguerMenu from './components/Menu/BurgerMenu';
import './App.css';

hotjar.initialize(1580200, 6);

moment.updateLocale('pt-BR');

function Contato() {
  return (
    <>
      <h2>Contato</h2>
    </>
  );
}

function App(props) {
  // Posição do usuário
  const { latitude, longitude } = usePosition();

  useEffect(() => {
    if (latitude !== undefined && longitude !== undefined) {
      props.setUserPos(latitude, longitude);
    }
  }, [latitude, longitude, props.setUserPos]);
  return (
    <div>
      <Router>
        <BurguerMenu />
        <div id="page-wrap">
          <Route exact path="/" component={Home} />
          <Route path="/contato" component={Contato} />
          <Route exact path="/oa/:id?" component={Search} />
        </div>
      </Router>

    </div>
  );
}

// export default App;
const mapStateToProps = (store) => ({
  lat: store.mapState.lat,
  lng: store.mapState.lng,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ setUserPos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
